import React from 'react';

export interface TransferTypeCellData {
  type?: string
}

export const TransferTypeCell = <T extends TransferTypeCellData>(row: T) => {
  const value: string = new Map([
    ['deposit', 'DEPOSIT'],
    ['ledgerEntry', 'LEDGER ENTRY'],
    ['withdrawal', 'WITHDRAWAL']
  ]).get(row?.type || 'ledgerEntry') || 'LEDGER ENTRY';

  return (
      <>{value}</>
  );
};